﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { RectangleItem, isOutsideShapes } from '@tk/utilities/tk.shape.detector';

export default class TKFilterGroup extends TKCustomElementFactory {
    filterDropdown?: HTMLElement;
    offset: number;
    wrapper?: HTMLElement;
    drilldownClassName: string;
    drilldownDropdownClassName: string;
    isDrilldownActive: boolean = false;
    backButton?: HTMLButtonElement;

    protected isOpenClass: string;

    constructor() {
        super();

        this.wrapper = this.closest('[data-tk-filter-group-wrapper]') || undefined;
        this.isOpenClass = this.getAttribute('data-tk-filter-group-show-class') || 'tk-filter-dropdown--open';
        this.drilldownDropdownClassName =
            this.getAttribute('data-tk-filter-drilldown-dropdown-class-name') || 'tk-filter-dropdown--drilldown';
        this.filterDropdown = this.querySelector(`#${this.getAttribute('data-tk-filter-group-dropdown')}`) || undefined;
        this.offset = Number(this.getAttribute('data-tk-filter-group-dropdown-offset')) || 4;
        this.drilldownClassName =
            this.getAttribute('data-tk-drilldown-class-name') || 'tk-filter-group-wrapper--drilldown';
        this.backButton = this.querySelector('[data-tk-filter-dropdown-jump-back]') || undefined;
    }

    connectedCallback(): void {
        if (!this.filterDropdown || !this.wrapper) return;
        this.attachClickListener();
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        this.filterDropdown?.remove();
    }

    attachClickListener(): void {
        const handleDropdownVisibility = this.toggleDropdown.bind(this);
        this.pushListener({ event: 'click', element: this, action: handleDropdownVisibility });
    }

    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({ event: 'click', element: window, action: handleClose });
        if (!this.backButton) return;
        const handleCloseDropdown = this.closeDropdown.bind(this);
        this.pushListener({ event: 'click', element: this.backButton, action: handleCloseDropdown });
    }

    toggleDropdown() {
        this.isDrilldownActive = this.wrapper!.classList.contains(this.drilldownClassName);
        this.resetDropdownVisibility();

        if (this.filterDropdown!.hidden) {
            document.body.insertAdjacentElement('beforeend', this.filterDropdown!);
            this.filterDropdown!.hidden = false;
            this.filterDropdown!.classList.add(this.isOpenClass);
            this.isDrilldownActive && this.filterDropdown!.classList.add(this.drilldownDropdownClassName);
            this.alignDropdownToButton();
        } else {
            this.filterDropdown!.hidden = true;
            this.filterDropdown!.classList.remove(this.isOpenClass);
            this.isDrilldownActive && this.filterDropdown!.classList.remove(this.drilldownDropdownClassName);
            this.insertAdjacentElement('beforeend', this.filterDropdown!);
        }
    }

    closeDropdown() {
        this.filterDropdown!.classList.remove(this.isOpenClass);
    }

    protected resetDropdownVisibility() {
        const openDropdowns = document.querySelectorAll<HTMLElement>('[data-tk-filter-dropdown]');
        const dropdownsToClose = Array.from(openDropdowns).filter((dropdown) => dropdown !== this.filterDropdown!);
        dropdownsToClose.forEach((dropdown) => {
            dropdown.hidden = true;
            dropdown.classList.remove(this.isOpenClass);
        });
    }

    alignDropdownToButton() {
        const { bottom, left } = this.getBoundingClientRect();
        this.filterDropdown!.style.top = `${bottom + window.scrollY + this.offset}px`;
        this.filterDropdown!.style.left = `${left + window.scrollX}px`;

        setTimeout(() => {
            this.registerCloseListener();
        }, 0);
    }

    close(event: MouseEvent) {
        if (!this.filterDropdown) return;
        const buttonRect = this.getBoundingClientRect();
        const dropdownRect = this.filterDropdown.getBoundingClientRect();
        const rectangles = [{ rectangle: buttonRect }, { rectangle: dropdownRect }] as RectangleItem[];
        if (isOutsideShapes(event, rectangles)) {
            this.filterDropdown!.hidden = true;
            this.filterDropdown.classList.remove(this.isOpenClass);
            this.removeListener(window);
        }
    }
}
